import { Fragment } from 'react/jsx-runtime';

import { StyledTable } from './Style';

type TableProps = {
  data: Array<Record<string, unknown>> | Record<string, unknown>;
};

const renderCellContent = (value: unknown) => {
  if (value === null || value === undefined) return null;
  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    return value;
  }
  return JSON.stringify(value);
};

const Table = ({ data }: TableProps) => {
  if (!data || (Array.isArray(data) && data.length === 0)) {
    return null;
  }

  const isArray = Array.isArray(data);
  const columns = isArray ? Object.keys(data[0]) : Object.keys(data);

  return (
      <Fragment>
        <StyledTable className="table table-head-filled width-100pct">
          <thead>
          <tr>
            {columns.map((col) => (
                <th key={col}>{col}</th>
            ))}
          </tr>
          </thead>
          <tbody>
          {isArray ? (
              data.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {columns.map((col) => (
                        <td key={col}>{renderCellContent(row[col])}</td>
                    ))}
                  </tr>
              ))
          ) : (
              <tr>
                {columns.map((col) => (
                    <td key={col}>{renderCellContent(data[col])}</td>
                ))}
              </tr>
          )}
          </tbody>
        </StyledTable>
      </Fragment>
  );
};

export default Table;
